var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"resource-exchange coming-soon"},[_c(_setup.PageHeader,{staticStyle:{"margin-bottom":"20px"},attrs:{"title":"资源交流信息"}}),_c('ming-table',{attrs:{"fields":_setup.column,"data":_setup.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }